import React, { useState, useEffect, useMemo } from 'react';
import * as S from './styles';
import { DatePicker, Tooltip, message } from 'antd';
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import { useLazyQuery } from '@apollo/client';
import { gqlSchema } from '../../../gql/schema';
import { RangeValue } from 'rc-picker/lib/interface';
import moment, { Moment } from 'moment';
import { StyledDatePicker } from '../styles';
import { generateCSVFromAccounts } from '../../../utils/createCSV';

interface Props {
  view?: string;
  report?: string;
  startDate?: string;
  compareDate?: string;
}

const BookCode = ({ view, report }: Props) => {
  const today = moment();
  const defaultRange = useMemo(() => [today.clone().startOf('day'), today.clone().endOf('day')], []);
  const defaultDate = useMemo(() => today.clone().startOf('day'), []);
  const [daysDifference, setDaysDifference] = useState<number>(0);
  let fileName = '';


  const [dateRange, setDateRange] = useState<[Moment, Moment]>([
    defaultRange[0].clone(),
    defaultRange[1].clone()
  ]);



  const [dateRangeComp1, setDateRangeComp1] = useState<Moment>(() =>
    defaultDate.clone()
  );
  const [dateRangeComp2, setDateRangeComp2] = useState<Moment>(() =>
    defaultDate.clone()
  );



  const [visibilityMap, setVisibilityMap] = useState<Record<string, boolean>>({});
  console.log("Date", dateRange);

  // Queries
  const [fetchAccounts, { loading, error, data }] = useLazyQuery(
    gqlSchema.AdminDashboardSchema.query.DashboardSuperAdmin.DASHBOARD.getAllBookCodes,
    {
      fetchPolicy: 'cache-first',
      onError: (err) => message.error(`Error fetching accounts: ${err.message}`),
    }
  );

  // const [fetchAvgAccounts, { loading: avgLoading, error: avgError, data: avgData }] = useLazyQuery(
  //   gqlSchema.AdminDashboardSchema.query.DashboardSuperAdmin.DASHBOARD.getAverageAccounts,
  //   {
  //     fetchPolicy: 'cache-first',
  //     onError: (err) => message.error(`Error fetching average accounts: ${err.message}`),
  //   }
  // );

  useEffect(() => {
    const [start, end] = dateRange;

    // if (view === 'Average') {
    //   if (start?.isValid() && end?.isValid()) {
    //     fetchAvgAccounts({
    //       variables: {
    //         startDate: start.toISOString(),
    //         endDate: end.toISOString(),
    //       },
    //     });
    //   }
    // } else
     if (view === 'Static' ||view === 'Average') {
      if (start?.isValid() && end?.isValid()) {
        fetchAccounts({
          variables: {
            startDate: start.toISOString(),
            endDate: end.toISOString(),
            type: 'Static',
          },
        });
      }
    } else if (view === 'Compare') {
      if (
        dateRangeComp1?.isValid() &&
        dateRangeComp2?.isValid()

      ) {
        console.log("Trigeered", dateRangeComp1.toISOString(), dateRangeComp2.toISOString());
        fetchAccounts({
          variables: {
            startDate: dateRangeComp1.toISOString(),
            endDate: dateRangeComp2.toISOString(),
            type: 'Compare',
          },
        });
      } else {
        message.warning('Please ensure both comparison dates are valid and the start date is before or equal to the end date.');
      }
    }
  }, [dateRange, dateRangeComp1, dateRangeComp2, view]);
  // const sample = [{ "id": "d72a0ab6-ffd2-420f-9b39-8e7051987631", "email": "nishith+studentorg2@argumentdriveninquiry.com", "firstName": "Nishith", "lastName": "Student Org 2", "organizationId": "fb736460-af7f-4fce-bdc0-dcf97fefda0d", "isTeacher": false, "isAssistant": false, "isAdiAdmin": false, "isAdiSuperAdmin": false, "isOrganizationAdmin": false, "created": "2025-03-05 11:24:32.668505+00", "lastLogin": "2025-04-25 16:23:45.195+00", "active": true, "walkthroughs": "", "loginAttempts": 0, "assistantsAllowed": 10, "isWriter": false, "acknowledgedPresentationMessage": null, "cleverId": null, "isFacilitator": false, "classlinkId": null, "isAllowedGrading": false, "isAllowedChat": false, "preferredRole": null, "betaEnrolled": null, "dismissedOnboarding": true, "isAdvancedSearch": false, "isEnterprise": true, "stripeCustomerId": null, "metadata": null, "cronStatus": null, "dismissedInsightsTutorial": false, "preferredSubscription": "organization", "lastCronStatusUpdate": null, "isGoogleStudent": false, "isGoogleTeacher": false, "isCanvasStudent": false, "isCanvasTeacher": false, "googleClassroomUserId": null, "canvasUserId": null, "isBookUser": false, "newWelcomeNote": false }, { "id": "a27286a8-dc9f-4907-9f8a-9326ae9bf104", "email": "nishith@argumentdriveninquiry.com", "firstName": "Nishith", "lastName": "Sahu", "organizationId": "ceefd4e3-2608-4051-9a79-90b305f7a6a7", "isTeacher": true, "isAssistant": false, "isAdiAdmin": false, "isAdiSuperAdmin": true, "isOrganizationAdmin": true, "created": "2024-01-22 17:01:53.779805+00", "lastLogin": "2025-04-25 14:25:10.571+00", "active": true, "walkthroughs": "manage_groups,add_students", "loginAttempts": 0, "assistantsAllowed": 1, "isWriter": false, "acknowledgedPresentationMessage": null, "cleverId": null, "isFacilitator": false, "classlinkId": null, "isAllowedGrading": true, "isAllowedChat": false, "preferredRole": "adi_super_admin", "betaEnrolled": false, "dismissedOnboarding": true, "isAdvancedSearch": false, "isEnterprise": true, "stripeCustomerId": "dfgdfbvdfg", "metadata": "{\"city\":\"Test\",\"state\":\"UU\",\"zipCode\":\"254569\",\"jobDescription\":\"25\"}", "cronStatus": null, "dismissedInsightsTutorial": false, "preferredSubscription": "user", "lastCronStatusUpdate": null, "isGoogleStudent": false, "isGoogleTeacher": true, "isCanvasStudent": true, "isCanvasTeacher": true, "googleClassroomUserId": null, "canvasUserId": "264450000000000154", "isBookUser": true, "newWelcomeNote": false }, { "id": "306b0220-70b3-419a-b6b9-89f59fd2edc7", "email": "nishith+booktest1@argumentdriveninquiry.com", "firstName": "Nishith", "lastName": "Test1", "organizationId": null, "isTeacher": true, "isAssistant": false, "isAdiAdmin": false, "isAdiSuperAdmin": false, "isOrganizationAdmin": false, "created": "2025-03-06 14:37:29.779606+00", "lastLogin": "2025-04-25 14:25:02.615+00", "active": true, "walkthroughs": "", "loginAttempts": 0, "assistantsAllowed": 3, "isWriter": false, "acknowledgedPresentationMessage": null, "cleverId": null, "isFacilitator": false, "classlinkId": null, "isAllowedGrading": false, "isAllowedChat": false, "preferredRole": "teacher", "betaEnrolled": null, "dismissedOnboarding": false, "isAdvancedSearch": false, "isEnterprise": true, "stripeCustomerId": null, "metadata": "{}", "cronStatus": null, "dismissedInsightsTutorial": false, "preferredSubscription": null, "lastCronStatusUpdate": null, "isGoogleStudent": false, "isGoogleTeacher": false, "isCanvasStudent": false, "isCanvasTeacher": false, "googleClassroomUserId": null, "canvasUserId": null, "isBookUser": true, "newWelcomeNote": false }]

  const handleDownload = (type?: string, id?: number) => {
    let sample: any[] = [];

    const viewType = view; // 'Average' | 'Static' | other
    // const get = (path: string) =>
    //   path?.split('.').reduce((o: any, key: string) => o?.[key], { avgData, data } as Record<string, any>);

    if (viewType === 'Average') {
      fileName=("Average");
      switch (id) {
        case 1:
          sample = data?.getAverageAccounts?.activeAccounts1 ?? [];
          break;
        case 2:
          sample = data?.getAverageAccounts?.newAccounts1 ?? [];
          break;
        case 3:
          sample = data?.getAverageAccounts?.inactiveAccounts1 ?? [];
          break;
        case 4:
          sample = data?.getAverageAccounts?.deletedAccounts1 ?? [];
          break;
      }
    } else {
      const keyMap: Record<number, string> = {
        1: 'totalCode1',
        2: 'totalScienceCode1',
        3: 'totalEngineeringCode1',
        4: 'totalMathCode1',
        5: 'totalCode2',
        6: 'totalScienceCode2',
        7: 'totalEngineeringCode2',
        8: 'totalMathCode2',
      };

      const key = keyMap[id!];
      sample = data?.getAllBookCodes?.[key] ?? [];
      fileName=(key);
    }

    generateCSVFromAccounts(sample,fileName);
  };



  const handleRangeChange = (dates: RangeValue<Moment>, _dateStrings: [string, string]) => {
    if (dates && dates[0] && dates[1]) {
      setDateRange([dates[0], dates[1]]);
      setDaysDifference(dates[1].diff(dates[0], 'days') + 1);
    }
  };
  const handleRangeChangeComp1 = (date: Moment | null, _dateString: string) => {
    if (!date) return;

    setDateRangeComp1(date);
  };

  const handleRangeChangeComp2 = (date: Moment | null, _dateString: string) => {
    if (!date) return;

    setDateRangeComp2(date);
  };



  if (loading ) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;
  // if (avgError) return <p>Error: {avgError.message}</p>;

  const accountCardsData = view === 'Average'
    ? [
      {
        id: 1, title: 'All Book Codes Used', count: daysDifference && daysDifference > 0
        ? Number((( data?.getAllBookCodes?.totalCode1?.length ?? 0) / daysDifference).toFixed(1))
          : 0
        , color: '#A565A7'
      },
      {
        id: 2,
        title: 'Science Book Codes Used',
        count: daysDifference && daysDifference > 0
        ? Number(((data?.getAllBookCodes?.totalScienceCode1?.length ?? 0) / daysDifference).toFixed(1))
          : 0,
        color: '#20BC89',
      },
      {
        id: 3,
        title: 'Math Book Codes Used',
        count: daysDifference && daysDifference > 0
        ? Number(((data?.getAllBookCodes?.totalMathCode1?.length ?? 0) / daysDifference).toFixed(1))
          : 0,
        color: '#FFAE51',
      },
      {
        id: 4,
        title: 'Eng Book Codes Used',
        count: daysDifference && daysDifference > 0
        ? Number(((data?.getAllBookCodes?.totalEngineeringCode1?.length ?? 0) / daysDifference).toFixed(1))
          : 0,
        color: '#F5CD1A',
      }
    ]
    : (view === 'Static') ? [
      { id: 1, title: 'Total Codes Used', count: data?.getAllBookCodes?.totalCode1?.length ?? 0, color: '#A565A7' },
      { id: 2, title: 'Science Codes Used', count: data?.getAllBookCodes?.totalScienceCode1?.length ?? 0, color: '#20BC89' },
      { id: 3, title: 'Engineering Codes Used', count: data?.getAllBookCodes?.totalEngineeringCode1?.length ?? 0, color: '#FFAE51' },
      { id: 4, title: 'Maths Codes Used', count: data?.getAllBookCodes?.totalMathCode1?.length ?? 0, color: '#F5CD1A' },
    ] :
      [
        { id: 1, title: 'Total Codes Used', count: data?.getAllBookCodes?.totalCode1?.length ?? 0, color: '#A565A7' },
        { id: 2, title: 'Science Codes Used', count: data?.getAllBookCodes?.totalScienceCode1?.length ?? 0, color: '#20BC89' },
        { id: 3, title: 'Engineering Codes Used', count: data?.getAllBookCodes?.totalEngineeringCode1?.length ?? 0, color: '#FFAE51' },
        { id: 4, title: 'Maths Codes Used', count: data?.getAllBookCodes?.totalMathCode1?.length ?? 0, color: '#F5CD1A' },
        { id: 5, title: 'Total Codes Used', count: data?.getAllBookCodes?.totalCode2?.length ?? 0, color: '#A565A7' },
        { id: 6, title: 'Science Codes Used', count: data?.getAllBookCodes?.totalScienceCode2?.length ?? 0, color: '#20BC89' },
        { id: 7, title: 'Engineering Codes Used', count: data?.getAllBookCodes?.totalEngineeringCode2?.length ?? 0, color: '#FFAE51' },
        { id: 8, title: 'Maths Codes Used', count: data?.getAllBookCodes?.totalMathCode2?.length ?? 0, color: '#F5CD1A' },
      ];
  console.log("data", data);
  const accountCardsChartData = accountCardsData.map((card) => ({
    title: card.title,
    height: card.count,
    color: card.color,
  })).slice(0, 4);

  const accountCardsChartDataComp = accountCardsData.map((card) => ({
    title: card.title,
    height: card.count,
    color: card.color,
  })).slice(4, 8);

  const maxRawHeight1 = Math.max(...accountCardsChartData.map(b => b.height || 0));
  const maxRawHeight2 = Math.max(...accountCardsChartDataComp.map(b => b.height || 0));



  const renderCardsAndChart = () => (
    <>
      <S.TopRow>
        <S.DateLabel>Show:</S.DateLabel>
        <StyledDatePicker
          style={{ border: '2px solid #767676', borderRadius: '16px' }}
          value={dateRange}
          onChange={handleRangeChange}
          allowClear={false}
        />
      </S.TopRow>

      <S.CardGrid>
        {accountCardsData.map((card) => {
          const isVisible = visibilityMap[card.title] ?? true;

          const toggleVisibility = (visible: boolean) => {
            setVisibilityMap((prev) => ({
              ...prev,
              [card.title]: !prev[card.title],
            }));
          };

          return (
            <S.Card key={card.title} color={card.color}>
              <S.CardTitle>{card.title}</S.CardTitle>
              <S.CardCount>{card.count}</S.CardCount>
              <S.CardIcons style={{ fontSize: '16px', alignItems: 'center' }}>
                <S.ToggleSwitch>
                  <S.ToggleOption active={isVisible} onClick={() => toggleVisibility(true)}>
                    <EyeOutlined style={{ fontSize: '20px' }} />
                  </S.ToggleOption>
                  <S.ToggleOption active={!isVisible} onClick={() => toggleVisibility(false)}>
                  <EyeInvisibleOutlined style={{ fontSize: '20px', transform: 'scaleX(-1)' }} />
                  </S.ToggleOption>
                </S.ToggleSwitch>

                <Tooltip title="Download">
                  <S.IconButton fontColor={card.color} size="compact" onClick={() => handleDownload(card.title, card.id)}>
                    {/* <DownloadOutlined style={{ marginRight: 4 }}/> */}
                    Download
                  </S.IconButton>
                </Tooltip>
              </S.CardIcons>
            </S.Card>
          );
        })}
      </S.CardGrid>

      <S.ChartWrapper>
        <S.ChartBaseline />
        <S.ChartBars>
          {accountCardsChartData
            .filter(bar => visibilityMap[bar.title] ?? true)
            .map(bar => {
              const normalizedHeight = maxRawHeight1 ? bar.height / maxRawHeight1 : 0;
              return (
                <S.Bar key={bar.title}>
                  <S.BarCountText>{bar.height}</S.BarCountText>
                  <S.BarCount height={normalizedHeight} color={bar.color} />
                  <S.BarLabel>{bar.title}</S.BarLabel>
                </S.Bar>
              );
            })}
        </S.ChartBars>
      </S.ChartWrapper>

    </>
  );

  const renderCardsAndChartAvg = () => (
    <>
      <S.TopRow>
        <S.DateLabel>Show:</S.DateLabel>
        <StyledDatePicker
          style={{ border: '2px solid #767676', borderRadius: '16px' }}
          value={dateRange}
          onChange={handleRangeChange}
          allowClear={false}
        />


        {/* <S.ViewType>{view} - {report}</S.ViewType> */}
      </S.TopRow>

      <S.CardGrid>
        {accountCardsData.map((card) => {
          const isVisible = visibilityMap[card.title] ?? true;

          const handleVisibilityToggle = (visible: boolean) => {
            setVisibilityMap((prev) => ({
              ...prev,
              [card.title]: !prev[card.title],
            }));
          };

          return (
            <S.Card key={card.title} color={card.color}>
              <S.CardTitle>{card.title}</S.CardTitle>
              <S.CardCount>{card.count}</S.CardCount>
              <S.CardIcons>
              <div style={{ fontSize: '16px', paddingTop: '18px' }}>
                <S.ToggleSwitch>
                  <S.ToggleOption active={isVisible} onClick={() => handleVisibilityToggle(true)}>
                    <EyeOutlined style={{ fontSize: '20px' }} />
                  </S.ToggleOption>
                  <S.ToggleOption active={!isVisible} onClick={() => handleVisibilityToggle(false)}>
                    <EyeInvisibleOutlined style={{ fontSize: '20px', transform: 'scaleX(-1)' }} />
                  </S.ToggleOption>
                </S.ToggleSwitch>
                </div>
                <S.CardSubtext>
                  {daysDifference}
                  <div>Day Average</div>
                </S.CardSubtext>


              </S.CardIcons>
            </S.Card>
          );
        })}
      </S.CardGrid>

      <S.ChartWrapper>
        <S.ChartBaseline />
        <S.ChartBars>
          {accountCardsChartData
            .filter(bar => visibilityMap[bar.title] ?? true)
            .map(bar => {
              const normalizedHeight = maxRawHeight1 ? bar.height / maxRawHeight1 : 0;
              return (
                <S.Bar key={bar.title}>
                  <S.BarCountText>{bar.height}</S.BarCountText>
                  <S.BarCount height={normalizedHeight} color={bar.color} />
                  <S.BarLabel>{bar.title}</S.BarLabel>
                </S.Bar>
              );
            })}
        </S.ChartBars>
      </S.ChartWrapper>

    </>
  );

  const renderCardsAndChartComp = () => (
    <>
      <S.TopRow>
        <S.DateLabel>Show:</S.DateLabel>
        <DatePicker
          style={{ border: '2px solid #767676', borderRadius: '10px' }}
          value={dateRangeComp1}
          onChange={handleRangeChangeComp1}
          allowClear={false}
        />
        {/* <S.ViewType>{view} - {report}</S.ViewType> */}
      </S.TopRow>

      <S.CardGrid>
        {accountCardsData.slice(0, 4).map((card) => {
          const isVisible = visibilityMap[card.title] ?? true;

          const toggleVisibility = (visible: boolean) => {
            setVisibilityMap((prev) => ({
              ...prev,
              [card.title]: !prev[card.title],
            }));
          };

          return (
            <S.Card key={card.title} color={card.color}>
              <S.CardTitle>{card.title}</S.CardTitle>
              <S.CardCount>{card.count}</S.CardCount>
              <S.CardIcons style={{ fontSize: '16px', alignItems: 'center' }}>
                <S.ToggleSwitch>
                  <S.ToggleOption active={isVisible} onClick={() => toggleVisibility(true)}>
                    <EyeOutlined style={{ fontSize: '20px' }} />
                  </S.ToggleOption>
                  <S.ToggleOption active={!isVisible} onClick={() => toggleVisibility(false)}>
                  <EyeInvisibleOutlined style={{ fontSize: '20px', transform: 'scaleX(-1)' }} />
                  </S.ToggleOption>
                </S.ToggleSwitch>

                <Tooltip title="Download">
                  <S.IconButton fontColor={card.color} size="compact" onClick={() => handleDownload(card.title, card.id)}>
                    {/* <DownloadOutlined style={{ marginRight: 4 }}/> */}
                    Download
                  </S.IconButton>
                </Tooltip>
              </S.CardIcons>
            </S.Card>
          );
        })}
      </S.CardGrid>

      <S.TopRow>
        <S.DateLabel>Show:</S.DateLabel>
        <DatePicker
          style={{ border: '2px solid #767676', borderRadius: '10px' }}
          value={dateRangeComp2}
          onChange={handleRangeChangeComp2}
          allowClear={false}
        />
        {/* <S.ViewType>{view} - {report}</S.ViewType> */}
      </S.TopRow>

      <S.CardGrid>
        {accountCardsChartDataComp.map((card) => {
          const isVisible = visibilityMap[card.title] ?? true;

          const toggleVisibility = (visible: boolean) => {
            setVisibilityMap((prev) => ({
              ...prev,
              [card.title]: !prev[card.title],
            }));
          };

          return (
            <S.Card key={card.title} color={card.color}>
              <S.CardTitle>{card.title}</S.CardTitle>
              <S.CardCount>{card.height}</S.CardCount>
              <S.CardIcons style={{ fontSize: '16px', alignItems: 'center' }}>
                <S.ToggleSwitch>
                  <S.ToggleOption active={isVisible} onClick={() => toggleVisibility(true)}>
                    <EyeOutlined style={{ fontSize: '20px' }}/>
                  </S.ToggleOption>
                  <S.ToggleOption active={!isVisible} onClick={() => toggleVisibility(false)}>
                  <EyeInvisibleOutlined style={{ fontSize: '20px', transform: 'scaleX(-1)' }} />
                  </S.ToggleOption>
                </S.ToggleSwitch>

                <Tooltip title="Download">
                  <S.IconButton fontColor={card.color} size="compact" onClick={() => console.log(`Download data for ${card.title}`)}>
                    {/* <DownloadOutlined /> */}
                    Download
                  </S.IconButton>
                </Tooltip>
              </S.CardIcons>
            </S.Card>
          );
        })}
      </S.CardGrid>

      <div style={{ display: 'flex', gap: '1px' }}>
        <S.ChartWrapper style={{ width: '48%' }}>
          <S.ChartBaseline />
          <S.ChartBars>
            {accountCardsChartData
              .filter(bar => visibilityMap[bar.title] ?? true)
              .map(bar => {
                const normalizedHeight = maxRawHeight1 ? bar.height / maxRawHeight1 : 0;
                return (
                  <S.Bar key={bar.title}>
                    <S.BarCountText>{bar.height}</S.BarCountText>
                    <S.BarCount height={normalizedHeight} color={bar.color} />
                  </S.Bar>
                );
              })}
          </S.ChartBars>
          <S.ChartDateLabel>{dateRangeComp1.format('MM/DD/YYYY')}</S.ChartDateLabel>
        </S.ChartWrapper>

        <S.ChartWrapper style={{ width: '48%' }}>
          <S.ChartBaseline />
          <S.ChartBars>
            {accountCardsChartDataComp
              .filter(bar => visibilityMap[bar.title] ?? true)
              .map(bar => {
                const normalizedHeight = maxRawHeight2 ? bar.height / maxRawHeight2 : 0;
                return (
                  <S.Bar key={`${bar.title}-2`}>
                    <S.BarCountText>{bar.height}</S.BarCountText>
                    <S.BarCount height={normalizedHeight} color={bar.color} />
                  </S.Bar>
                );
              })}
          </S.ChartBars>
          <S.ChartDateLabel>{dateRangeComp2.format('MM/DD/YYYY')}</S.ChartDateLabel>
        </S.ChartWrapper>
      </div>


    </>
  );

  return (
    <div style={{ marginBottom: '40px' }}>
      {view === 'Static' && (
        <>
          {/* <h3>{view} View</h3> */}
          {renderCardsAndChart()}
        </>
      )}

      {view === 'Compare' && (
        <>
          {/* <h3>{view} View</h3> */}
          {renderCardsAndChartComp()}
        </>
      )}
      {view === 'Average' && (
        <>
          {/* <h3>{view} View</h3> */}
          {renderCardsAndChartAvg()}
        </>
      )}
    </div>
  );

};

export default BookCode;